import { render } from "./App.vue?vue&type=template&id=3a99da3c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3a99da3c&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__